import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import { Link } from 'gatsby';
import { alpha, useTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LanguageIcon from '@mui/icons-material/Language';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TopNav from 'components/TopNav';
import { DocContext } from '../../DocMdx';
import MuiLink from '@mui/material/Link';

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import NavItem from '../../../Main/components/Topbar/components/NavItem';
import { useTranslation, Trans, Translation } from 'react-i18next';

const LANGS = ['en', 'zh', 'jp'];

const LANGNAMES = {
  'en': 'English',
  'zh': '中文',
  'jp': '日本語',
};
const HighlightTitle = ({title,path,filter}) => {
	let rtntitle = " <b> "+path.split("/")[0].replaceAll("-"," ") +"</b> > "+title.replace(filter,`<b style="color:#00adef" >${filter}</b>`)
	return (<span style={{textTransform:"capitalize"}} dangerouslySetInnerHTML={{__html:rtntitle}}/>);
}
const HighlightBody = ({body,filter}) => {
	const idx = body.indexOf(filter)==-1?0:body.indexOf(filter);
	const start = idx-50<0?0:(idx-50);
	const end = (idx+filter.length+50)<body.length?(idx+filter.length+50):(body.length);
	let rtnbody = "..."+body.substr(start,end-start)+"...";
	rtnbody = rtnbody.replace(filter,`<b style="color:#00adef" >${filter}</b>`)
	return (<span style={{opacity:0.9}} dangerouslySetInnerHTML={{__html:rtnbody}}/>);
}
const Searcher =({nodes}) => {
	let { t } = useTranslation()
  const { lang, path } = React.useContext(DocContext);
  const theme = useTheme();
  const [ anchorEl, setAnchorEl ] = useState(null);

  const [openedPopoverId, setOpenedPopoverId] = useState(null);
  
  const handleClick = (event) => {
		searching();
    setAnchorEl(event.target);
    setOpenedPopoverId('Searcher');
  };
  
  const handleClose = () => {
    setAnchorEl(null);
    setOpenedPopoverId(null);
  };
	
	const [filterData, setFilterData] = useState([]);
	const [values, setValues] = useState({
	    filter: '',
	});
	const handleChange = (prop) => (event) => {
	  setValues({ ...values, [prop]: event.target.value });
	};
	const searching = () => {
		if(values.filter){
			let _nodes = nodes.filter((item)=>{
				return item.fields.lang == lang &&
				(item.frontmatter.title.toLowerCase().indexOf(values.filter.toLowerCase())>=0||
				item.rawBody.toLowerCase().indexOf(values.filter.toLowerCase())>=0)
				
				
			});
			_nodes.forEach((item)=>{
				item.filter = values.filter;
			})
			setFilterData(_nodes);
		}else{
			setFilterData(nodes);
		}
	}
	
	return (
    <Box>
			<Paper
				component="div"
				sx={{ p: '0px 4px', display: 'flex', alignItems: 'center', width: 400 }}
			>
				<InputBase
					sx={{ ml: 1, flex: 1,marginTop:'-10px',marginBottom:'-10px' }}
					value={values.filter}
					variant="standard"
					onChange={handleChange('filter')}
					placeholder={t("Search")+" flomesh.io"}
					inputProps={{ 'aria-label': 'search flomesh.io' }}
				/>
				<IconButton type="submit" sx={{ p: '10px' }} aria-label="search" onClick={handleClick}>
					<SearchIcon />
				</IconButton>
			</Paper>
		
		  <Popover
		    elevation={3}
		    id={'Searcher'}
		    open={openedPopoverId === 'Searcher'}
		    anchorEl={anchorEl}
		    onClose={handleClose}
		    anchorOrigin={{
		      vertical: 'bottom',
		      horizontal: 'right',
		    }}
		    transformOrigin={{
		      vertical: 'top',
		      horizontal: 'right',
		    }}
		    sx={{
		      '.MuiPaper-root': {
		        width: 400,
		        maxHeight: 600,
		        marginTop: 2,
		        borderTopRightRadius: 0,
		        borderTopLeftRadius: 0,
		        borderBottomRightRadius: 8,
		        borderBottomLeftRadius: 8,
		        borderTop: `3px solid ${theme.palette.primary.main}`,
		      },
		    }}
		  >
			{filterData&&filterData.length>0?
			<List sx={{ width: '100%', maxWidth: 400, bgcolor: 'background.paper' }}>
					{filterData.map((d, i) => (
					<ListItem alignItems="flex-start" style={{borderBottom:'1px solid #ececec'}}>
					
					  <Button
					    fullWidth
							component={Link}
							to={`/pipy/docs/${d.fields.lang}/${d.fields.path}`}
					    sx={{
					      justifyContent: 'flex-start',
					      color:theme.palette.text.primary,
					      backgroundColor:'transparent',
					      
					    }}
					  >
						<ListItemText
							primary={
								<React.Fragment>
								  <HighlightTitle title={d.frontmatter.title} path={d.fields.path} filter={d.filter}/>
								</React.Fragment>
							}
							secondary={
								<React.Fragment>
									<Box
										fullWidth
										sx={{
											justifyContent: 'flex-start',
											color:theme.palette.text.primary,
											backgroundColor:'transparent',
										}}
									>
										<HighlightBody body={d.rawBody} filter={d.filter}/>
									</Box>
								</React.Fragment>
							}
						/>
						</Button>
					</ListItem>
					
					))}
				</List>
				:
				<Box style={{lineHeight:'80px',textAlign:'center',opacity:0.7}}>No Results</Box>
				}
		  </Popover>
    </Box>
	)
}
const LangSelect = () => {
	let { t ,i18n} = useTranslation()
  const theme = useTheme();
  const { lang, path } = React.useContext(DocContext);
  const [ anchorEl, setAnchorEl ] = useState(null);

  const [openedPopoverId, setOpenedPopoverId] = useState(null);
  
  const changeLang = (lang) => {
  	i18n.changeLanguage(lang);
  }
  const handleClick = (event) => {
    setAnchorEl(event.target);
    setOpenedPopoverId('LangSelect');
  };
  
  const handleClose = () => {
    setAnchorEl(null);
    setOpenedPopoverId(null);
  };
  return (
    <Box>
	  <Box
	    display={'flex'}
	    alignItems={'center'}
		aria-describedby={'LangSelect'}
	    sx={{ cursor: 'pointer' }}
	    onClick={handleClick}
	  >
	    <LanguageIcon marginRight={1} sx={{ marginRight:'5px !important',color: 'text.primary',width: 5,height: 5,fontSize:'18px !important'}}/>
	    <Typography
	      color={'text.primary'}
	    >
	      {LANGNAMES[lang]} 
	    </Typography>
	    <ExpandMoreIcon
	      sx={{
	        marginLeft: 1,
	        width: 16,
	        height: 16,
			fontSize:'18px !important',
	        transform: openedPopoverId === 'LangSelect' ? 'rotate(180deg)' : 'none',
	        color: 'text.primary',
	      }}
	    />
	  </Box>
      <Popover
        elevation={3}
        id={'LangSelect'}
        open={openedPopoverId === 'LangSelect'}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          '.MuiPaper-root': {
            maxWidth: 200,
            padding: 2,
            marginTop: 2,
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
            borderBottomRightRadius: 8,
            borderBottomLeftRadius: 8,
            borderTop: `3px solid ${theme.palette.primary.main}`,
          },
        }}
      >
	    <Grid container spacing={0.5}>
	      {LANGS.map((l, i) => (
	        <Grid item key={i} xs={12}>
	          <Button
	            component={Link}
							onClick={() => changeLang(l)}
	            to={`/pipy/docs/${l}/${path}`}
	            fullWidth
	            sx={{
	              justifyContent: 'flex-start',
	              color:theme.palette.text.primary,
	              backgroundColor:'transparent',
	              fontWeight: 400,
	            }}
	          >
	            {LANGNAMES[l]}
	          </Button>
	        </Grid>
	      ))}
	    </Grid>
      </Popover>
    </Box>
  );
}
const Topbar = ({ onSidebarOpen, pages, nodes }) => {
	let { t } = useTranslation()
  const theme = useTheme();
  const { mode } = theme.palette;
	const {
		products: productPages,
    githubs: githubPages
	} = pages;

  return (
    <Box
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
      width={1}
    >
      <Box
        display={'flex'}
        component={Link}
        to="/"
        title="Flomesh"
        height={{ xs: 45, md: 45 }}
      >
        <Box
          component={'img'}
          src={
            mode === 'light'
              ? '/img/flomesh.png'
              : '/img/flomesh-white.png'
          }
          height={1}
        />
      </Box>
      <Box sx={{ display: { xs: 'none', md: 'flex' } }} alignItems={'center'}>
				<Box><Searcher nodes={nodes} /></Box>
				<Box marginLeft={4}>
					<MuiLink component={Link} to="/" underline="none" color={theme.palette.text.primary}>
					{t("Home")}
					</MuiLink>
				</Box>
        <Box marginLeft={4}>
          <NavItem
            title={t("Products")}
            id={'product-pages'}
            items={productPages}
            colorInvert={false}
          />
        </Box>
				<Box marginLeft={4}>
					<MuiLink component={Link} to="/docs" underline="none" color={theme.palette.text.primary}>
					{t("Docs")}
					</MuiLink>
				</Box>
				<Box marginLeft={4}>
					<MuiLink to="https://blog.flomesh.io" component={Link} target="_blank" underline="none" color={theme.palette.text.primary}>{t("Blog")}</MuiLink>
				</Box>
				<Box marginLeft={4}>
          <NavItem
            title={'Githubs'}
            id={'gihub-pages'}
            items={githubPages}
            colorInvert={false}
          />
				</Box>
				<Box sx={{ display: { xs: 'none', md: 'flex' } }} alignItems={'center'}>
					<Box  marginLeft={3}>
						<LangSelect />
					</Box>
					<Box marginLeft={3}>
						<TopNav />
					</Box>
					<Box marginLeft={4}>
						<Button
							component={Link}
							to="/pipy/download"
							variant="contained"
							color="primary"
							target="blank"
							size="large"
						>
							{t("Download")}
						</Button>
					</Box>
				</Box>
      </Box>
			
			<Box sx={{ display: { xs: 'flex', md: 'none' } }} alignItems={'center'}>
				<Box  marginLeft={1}>
					<LangSelect />
				</Box>
				<Box marginLeft={1}>
					<TopNav />
				</Box>
				<Button
				  marginLeft={1}
					onClick={() => onSidebarOpen()}
					aria-label="Menu"
					sx={{
						borderRadius: 2,
						minWidth: 'auto',
						padding: 1,
						borderColor: alpha(theme.palette.divider, 0.2),
					}}
				>
					<MenuIcon />
				</Button>
			</Box>
    </Box>
  );
};

Topbar.propTypes = {
  onSidebarOpen: PropTypes.func,
	nodes: PropTypes.array,
  pages: PropTypes.object
};

export default Topbar;
